<template>
  <div class="upcoming-content">
    <div class="div-padding">
      <pp-steps :step="2" />
    </div>
    <div class="divider_color" />
    <div class="step">
      <div class="demo-ruleForm">
        <label class="title-label">
          {{ $t('ppwc.p8') }}
        </label>
        <van-row>
          <van-field
            v-model.trim="ruleForm.serial_no"
            :placeholder="$t('ppwc.p8')"
            class="serial_input"
            :error="serial_error"
            disabled
          /></van-col>
        </van-row>
        <div class="infomation">
          <p>*{{ $t('ppwc.p16') }}</p>
        </div>
        <label class="title-label">
          {{ $t('ppwc.p20') }}
        </label>
        <van-row>
          <van-field
            v-model.trim="ruleForm.name"
            :placeholder="$t('ppwc.p20')"
            class="name_input"
            :error="name_error"
            @blur="validate('name')"
          />
        </van-row>
        <label class="title-label">
          {{ $t('ppwc.p23') }}
        </label>
        <van-row class="id-type-row">
          <van-field
            readonly
            clickable
            :error="id_type_error"
            class="id_type_input"
            :placeholder="$t('ppwc.p68')"
            :value="ruleForm.id_type"
            @click="showIdType = true"
          />
        </van-row>
        <van-row>
          <van-field
            v-model.trim="ruleForm.id_num"
            :placeholder="$t('ppwc.p27')"
            class="id_num_input"
            :error="id_num_error"
            @blur="validate('id_num')"
          />
        </van-row>
        <label class="title-label">
          {{ $t('ppwc.p28') }}
        </label>
        <van-row>
          <van-field
            readonly
            clickable
            :error="nationality_error"
            class="platform_input"
            :value="ruleForm.platform"
            :placeholder="$t('ppwc.p68')"
            @click="showPlatforms = true"
          />
        </van-row>
        <label class="title-label">
          {{ $t('ppwc.p33') }}
        </label>
        <van-row>
          <van-field
            readonly
            clickable
            :error="date_error"
            class="date_input"
            :value="ruleForm.date"
            :placeholder="$t('ppwc.p68')"
            @click="showDate = true"
          />
        </van-row>
        <label class="title-label">
          {{ $t('ppwc.p106') }}
        </label>
        <van-row>
          <van-field
            readonly
            clickable
            :error="preferred_error"
            class="preferred_input"
            :value="ruleForm.preferred"
            :placeholder="$t('ppwc.p68')"
            @click="showPreferred = true"
          />
        </van-row>
        <label class="title-label">
          {{ $t('ppwc.p14') }}
        </label>
        <van-row>
          <van-field
            v-model.trim="ruleForm.email"
            :placeholder="$t('ppwc.p14')"
            class="email_input"
            :error="email_error"
            @blur="validate('email')"
          />
        </van-row>
        <van-row class="no-border">
          <van-checkbox
            v-model="ruleForm.agreement"
            class="agreement"
            :class="{ error: (!ruleForm.agreement && agreement_error) }"
            checked-color="#289753"
            shape="square"
          >
            {{ $t('ppwc.p36') | format }} <router-link
              class="primary_color"
              target="_blank"
              to="/user-agreement"
            >
              {{ $t('ppwc.p37') }}
            </router-link>
          </van-checkbox>
          <div>
            <van-checkbox
              v-if="showAgreement2"
              v-model="ruleForm.agreement2"
              :class="{ error: (!ruleForm.agreement2 && agreement2_error) }"
              checked-color="#289753"
              shape="square"
            >
              {{ $t('ppwc.p36') | format }} <router-link
                class="primary_color"
                target="_blank"
                to="/privacy-policy"
              >
                {{ $t('ppwc.p47') }}
              </router-link>
            </van-checkbox>
          </div>
        </van-row>
      </div>

      <div
        class="confirm"
        @click="submitForm('ruleForm')"
      >
        <p>Confirm</p>
      </div>

      <van-popup
        v-model="showIdType"
        position="bottom"
      >
        <van-picker
          show-toolbar
          :columns="IdType_columns"
          :cancel-button-text="$t('ppwc.p31')"
          :confirm-button-text="$t('ppwc.p32')"
          @cancel="showIdType = false"
          @confirm="onConfirmIdType"
        />
      </van-popup>
      <van-popup
        v-model="showPlatforms"
        position="bottom"
      >
        <van-picker
          show-toolbar
          :columns="platforms"
          :cancel-button-text="$t('ppwc.p31')"
          :confirm-button-text="$t('ppwc.p32')"
          @cancel="showPlatforms = false"
          @confirm="onConfirmsPlatforms"
        />
      </van-popup>
      <van-popup
        v-model="showPreferred"
        position="bottom"
      >
        <van-picker
          show-toolbar
          :columns="Preferred_columns"
          :cancel-button-text="$t('ppwc.p31')"
          :confirm-button-text="$t('ppwc.p32')"
          @cancel="showPreferred = false"
          @confirm="onConfirmsPreferred"
        />
      </van-popup>
      <van-popup
        v-model="showDate"
        position="bottom"
      >
        <van-datetime-picker
          v-model="currentDate"
          type="date"
          :min-date="minDate"
          :cancel-button-text="$t('ppwc.p31')"
          :confirm-button-text="$t('ppwc.p32')"
          @cancel="showDate = false"
          @confirm="onConfirmDate"
        />
      </van-popup>
      <p v-if="tips">
        {{ tips }}
      </p>
    </div>
  </div>
</template>

<script>
import {
  getPlatforms
} from '@/api/official'
import ppSteps from './ppSteps.vue'
import moment from 'moment'

export default {
  filters: {
    format: function(val) {
      return val.replace('{link}', '')
    }
  },
  components: {
    ppSteps
  },
  props: {
    param: {
      type: Object,
      default: {}
    }
  },
  data() {
    var checkEmail = (rule, value, callback) => {
      var reg = new RegExp('^[a-z0-9A-Z]+[- | a-z0-9A-Z . _]+@([a-z0-9A-Z]+(-[a-z0-9A-Z]+)?\\.)+[a-z]{2,}$')
      if (!reg.test(value)) {
        callback(new Error('Please enter a valid email address'))
      } else {
        callback()
      }
    }
    return {
      IdType_columns: [this.$t('ppwc.p24'), this.$t('ppwc.p25'), this.$t('ppwc.p26')],
      Preferred_columns: [this.$t('ppwc.p40'), this.$t('ppwc.p41'), this.$t('ppwc.p42'), this.$t('ppwc.p43'), this.$t('ppwc.p44'), this.$t('ppwc.p45')],
      currentDate: new Date(),
      showIdType: false,
      showPlatforms: false,
      showPreferred: false,
      showDate: false,
      serial_error: false,
      email_error: false,
      name_error: false,
      id_type_error: false,
      id_num_error: false,
      nationality_error: false,
      preferred_error: false,
      date_error: false,
      agreement_error: false,
      agreement2_error: false,
      labelPosition: 'top',
      tips: '',
      minDate: new Date(1900, 1, 1),
      ruleForm: {
        serial_no: '',
        email: '',
        name: '',
        id_type: '',
        id_num: '',
        platform: '',
        date: '',
        agreement: false,
        agreement2: false
      },
      platforms: null,
      showAgreement2: false,
      rules: [{
          param: 'serial_no',
          error: 'serial_error',
          message: this.$t('ppwc.p17')
        },
        {
          param: 'name',
          error: 'name_error',
          message: this.$t('ppwc.p19')
        },
        {
          param: 'id_type',
          error: 'id_type_error',
          message: this.$t('ppwc.p68') + ' ' + this.$t('ppwc.p23')
        },
        {
          param: 'id_num',
          error: 'id_num_error',
          message: this.$t('ppwc.p21')
        },
        {
          param: 'platform',
          error: 'nationality_error',
          message: this.$t('ppwc.p30')
        },
        {
          param: 'date',
          error: 'date_error',
          message: this.$t('ppwc.p35')
        },
        {
          type: 'date',
          param: 'date',
          error: 'date_error',
          message: this.$t('ppwc.p70')
        },
        {
          param: 'preferred',
          error: 'preferred_error',
          message: this.$t('ppwc.p39')
        },
        {
          param: 'email',
          error: 'email_error',
          message: this.$t('ppwc.p18')
        },
        {
          type: 'email',
          param: 'email',
          error: 'email_error',
          message: this.$t('ppwc.p15')
        },
        {
          param: 'agreement',
          error: 'agreement_error',
          message: this.$t('ppwc.p36').replace('{link}', this.$t('ppwc.p37'))
        },
        {
          param: 'agreement2',
          error: 'agreement2_error',
          message: this.$t('ppwc.p36').replace('{link}', this.$t('ppwc.p47'))
        },
      ]
    }
  },
  created() {
    this.$store.commit('changeTab', 1)

    this.ruleForm = this.$route.query
    if(this.$route.query.agreement) {
      this.ruleForm.agreement = !!this.$route.query.agreement
    }
    if(this.$route.query.agreement2) {
      this.ruleForm.agreement2 = !!this.$route.query.agreement2
    }
    // if(!this.ruleForm.id_type) {
    //   this.ruleForm.id_type = this.$t('ppwc.p24')
    // }
    if(this.ruleForm.platform) {
      this.onConfirmsPlatforms(this.ruleForm.platform)
    }
    this.getlist()
  },
  mounted() {
    let u = navigator.userAgent
    let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1
    if(isAndroid) {
      document.querySelector('.name_input').addEventListener('click', function(e) {
        document.querySelector('.serial_input').scrollIntoView({ block: 'start', behavior: 'smooth' })
      })
      document.querySelector('.id_num_input').addEventListener('click', function(e) {
        document.querySelector('.name_input').scrollIntoView({ block: 'start', behavior: 'smooth' })
      })
      document.querySelector('.email_input').addEventListener('click', function(e) {
        document.querySelector('.preferred_input').scrollIntoView({ block: 'start', behavior: 'smooth' })
      })
    }
  },
  methods: {
    onConfirmIdType(value) {
      this.ruleForm.id_type = value;
      this.showIdType = false;
      this.validate('id_type')
    },
    onConfirmsPlatforms(value) {
      this.ruleForm.platform = value;
      let temp = [ 'Austria', 'Belgium', 'Bulgaria', 'Croatia', 'Republic of Cyprus', 'Czech Republic', 'Denmark', 'Estonia', 'Finland', 'France', 'Germany', 'Greece', 'Hungary', 'Ireland', 'Italy', 'Latvia', 'Lithuania', 'Luxembourg', 'Malta', 'Netherlands', 'Poland', 'Portugal', 'Romania', 'Slovakia', 'Slovenia', 'Spain', 'Sweden and the UK.']
      this.showAgreement2 = temp.some(v => {
        return v === value
      })
      this.showPlatforms = false;
      this.validate('platform')
    },
    onConfirmsPreferred(value) {
      this.ruleForm.preferred = value;
      this.showPreferred = false;
      this.validate('preferred')
    },
    onConfirmDate(value) {
      let t = new Date(value)
      this.ruleForm.date = t.getFullYear() + '-' + (t.getMonth() < 9 ? '0': '') + (t.getMonth() + 1) + '-' + (t.getDate() < 10 ? '0': '') + t.getDate();
      this.showDate = false;
      this.validate('date')
    },
    getlist() {
      getPlatforms()
        .then(res => {
          if(res.code == 0) {
            this.platforms = res.data
          }
        })
        .catch(err => {
          alert('network issue, Please try again later.')
        })
    },
    validate(name) {
      console.log(name)
      if(name) {
        this.rules.every((item) => {
          console.log(name, item.param , name === item.param)
          if(name === item.param) {
            if(item.type === 'date') {
              let value = this.ruleForm[item.param]
              let now = moment().subtract(18, 'y').format('YYYY-MM-DD')

              if(value > now) {
                this[item.error] = true
                this.$toast(item.message)
                return false
              }else {
                this[item.error] = false
                return true
              }
            }
            if(item.type === 'email') {
              var reg = new RegExp('^[a-z0-9A-Z]+[- | a-z0-9A-Z . _]+@([a-z0-9A-Z]+(-[a-z0-9A-Z]+)?\\.)+[a-z]{2,}$')
              if (!reg.test(this.ruleForm[item.param])) {
                this[item.error] = true
                this.$toast(item.message)
                return false
              } else {
                this[item.error] = false
                return true
              }
            }
            if(!this.showAgreement2 && item.type === 'agreement2') {
              return true
            }
            if (this.ruleForm[item.param] === '' || this.ruleForm[item.param] === undefined || this.ruleForm[item.param] === false) {
              this[item.error] = true
              this.$toast(item.message)
              return false
            } else {
              this[item.error] = false
              return true
            }
          }
          return true
        })
      } else {
        return this.rules.every((item) => {
          if(item.type === 'date') {
            let value = this.ruleForm[item.param]
            let now = moment().subtract(18, 'y').format('YYYY-MM-DD')

            if(moment(value).isAfter(now)) {
              this[item.error] = true
              this.$toast(item.message)
              return false
            }else {
              this[item.error] = false
              return true
            }
          }
          if(item.type === 'email') {
            var reg = new RegExp('^[a-z0-9A-Z]+[- | a-z0-9A-Z . _]+@([a-z0-9A-Z]+(-[a-z0-9A-Z]+)?\\.)+[a-z]{2,}$')
            if (!reg.test(this.ruleForm[item.param])) {
              this[item.error] = true
              this.$toast(item.message)
              return false
            } else {
              this[item.error] = false
              return true
            }
          }
          if(!this.showAgreement2 && item.param === 'agreement2') {
            return true
          }
          if (this.ruleForm[item.param] === '' || this.ruleForm[item.param] === undefined || this.ruleForm[item.param] === false) {
            this[item.error] = true
            this.$toast(item.message)
            return false
          } else {
            this[item.error] = false
            return true
          }
        })
      }
    },
    submitForm(formName) {
      if (this.validate()) {
        let idType = {}
        idType[this.$t('ppwc.p24')] = '1'
        idType[this.$t('ppwc.p25')] = '2'
        idType[this.$t('ppwc.p26')] = '3'
        let preferredType = {}
        preferredType[this.$t('ppwc.p40')] = '1'
        preferredType[this.$t('ppwc.p41')] = '2'
        preferredType[this.$t('ppwc.p42')] = '3'
        preferredType[this.$t('ppwc.p43')] = '4'
        preferredType[this.$t('ppwc.p44')] = '5'
        preferredType[this.$t('ppwc.p45')] = '6'


        this.ruleForm.idTypeTxt = idType[this.ruleForm.id_type]

        this.ruleForm.preferredTxt = preferredType[this.ruleForm.preferred]
        this.ruleForm.birthday = this.ruleForm.date
        this.ruleForm.lang = this.$i18n.locale

        console.log('form2 data is ', this.ruleForm)
        console.log(this.ruleForm.date)
        this.$emit('setStep', 3, this.ruleForm)
      }
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.upcoming-content {
  padding: 20px 0px 60px 0px;
  font-size: 28px;
  line-height: 26px;
}
.div-padding {
  padding: 0 24px;
}
.step {
  padding: 0 24px;
  .demo-ruleForm {
    padding: 30px 0px;
    /deep/.van-field__control {
      color: #289753;
    }
    /deep/.van-checkbox__icon {
      font-size: 28px;
    }
    /deep/.van-field--error .van-field__control, /deep/.van-field--error .van-field__control::placeholder {
      color: #942321;
      font-weight: normal;
    }
    /deep/.van-field__control:disabled {
      color: #289753;
      -webkit-text-fill-color: #289753;
    }
    /deep/.van-checkbox__label {
      color: #727272;
    }
    /deep/.van-checkbox.error {
      .van-icon {
        border-color: #942321;
      }
      .van-checkbox__label {
        color: #942321;
        a {
          color: #942321;
        }
      }
    }
    .van-divider {
      margin: 14px 0px;
    }
    .van-row {
      border: 1PX solid #DCDFE6;
      margin-bottom: 26px;
      border-radius: 8px;
    }
    .van-row.no-border {
      border: none;
      margin-bottom: 0px;
      a {
        text-decoration: underline!important;
      }
    }
    .id-type-row {
     margin-bottom: 18px;
    }
    .title-label {
      font-weight: bold;
      line-height: 44px;
    }
    /deep/.van-field__control {
      // color: #289753;
    }
    .serial_input {
      padding-left: 80px;
      background: url('/official_mobile/static/img/events/activate/1/no_g.png') no-repeat 18px center;
      background-size: 38px auto;
    }
    .email_input {
      padding-left: 80px;
      background: url('/official_mobile/static/img/events/activate/2/email_g.png') no-repeat 18px center;
      background-size: 38px auto;
    }
    .name_input {
      padding-left: 80px;
      background: url('/official_mobile/static/img/events/activate/2/name_g.png') no-repeat 18px center;
      background-size: 38px auto;
    }
    .id_type_input {
      padding-left: 80px;
      background: url('/official_mobile/static/img/events/activate/2/id_type.png') no-repeat 18px center;
      background-size: 38px auto;
    }
    .platform_input {
      padding-left: 80px;
      background: url('/official_mobile/static/img/events/activate/2/nationality.png') no-repeat 18px center;
      background-size: 38px auto;
    }
    .preferred_input {
      padding-left: 80px;
      background: url('/official_mobile/static/img/events/activate/2/chip.png') no-repeat 18px center;
      background-size: 38px auto;
    }
    .date_input {
      padding-left: 80px;
      background: url('/official_mobile/static/img/events/activate/2/date_g.png') no-repeat 18px center;
      background-size: 38px auto;
    }
    .infomation {
      // display: inline-block;
      padding: 26px 24px;
      // border: 1px solid #289753;
      margin-left: -24px;
      margin-right: -24px;
      background-color: #f5f5f5;
      margin-bottom: 6px;
      p {
        margin: 0px;
        font-size: 24px;
        line-height: 20px;
        color: #a5a5a5;
      }
    }
    .agreement {
      margin-bottom: 10px;
    }
  }
  .confirm {
      width: 86%;
      height: 80px;
      margin: 50px auto 0px auto;
      background: url('/official_mobile/static/img/events/activate/banner_01.png') no-repeat center center;
      background-size: 100%;
      cursor: pointer;
      border-radius: 8px;
      p {
        text-align: center;
        line-height: 80px;
        font-size: 30px;
        color: #fff;
      }
    }
}
</style>
